import { render, staticRenderFns } from "./DischargesReport.vue?vue&type=template&id=5536f64c"
import script from "./DischargesReport.vue?vue&type=script&lang=js"
export * from "./DischargesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports